import axios from "axios";
import config from "../../config/index";
// ------------------------------------------ UTILS
import { FhsInterceptors } from "./index_interceptors";
// ------------------------------------------ MODULES
import { FhsAuthApi } from "./auth/auth_api";
// ------------------------------------------ CANCEL TOKEN

// ------------------------------------------ INSTANCE
export const FhsAxios = axios.create({
  baseURL: config.baseUrl + config.apiVersion,
  headers: {
    "Content-type": "application/json",
    apiKey: config.apiKey
  }
});
// ------------------------------------------ API
export const FhsAPI = {
  auth: FhsAuthApi
};

FhsAxios.interceptors.request.use(
  FhsInterceptors.onRequest,
  FhsInterceptors.onError
);

FhsAxios.interceptors.response.use(
  FhsInterceptors.onResponse,
  FhsInterceptors.onError
);
